<template>
    <div class="dc-user-full is-goals">
        <h2>{{$t('views.createUserFull.goals.mainTitle')}}</h2>
        <p>{{$t('views.createUserFull.goals.p')}}</p>
        <div class="dc-user-full__btns">
            <el-button
            v-for="key in allKeys" :key="key"
            :class="{'is-selected': selectedKeys[key]}"
            size="default" @click="tapKey(key)">{{$t(`views.createUserFull.goals.${key}`)}}</el-button>
        </div>
        <p>{{$t('views.createUserFull.goals.inputTitle')}}</p>
        <el-input type="textarea" v-model="inputText" 
            :maxlength="-1" :show-word-limit="false" :autosize="{ minRows: 3, maxRows: 8 }">
        </el-input>
        <el-button class="dc-user-full__btn-next" :disabled="Object.keys(selectedKeys).length == 0" type="primary" size="default" @click="onNext">{{$t('views.createUserFull.btnNext')}}</el-button>
    </div>
</template>

<script>
export default {
    name: 'userFullGoals',
    data () {
        return {
            allKeys: [
                'Diversification',
                'ReturnPotential',
                'CashFlow',
                'TaxBenefits',
                'OpportunityZones',
            ],
            selectedKeys: {},
            inputText: '',
        }
    },
    methods: {
        tapKey (key) {
            this.$set(this.selectedKeys, key, !this.selectedKeys[key])
        },
        onNext () {
            let goals = {
                selectedKeys: this.selectedKeys || {},
                input: this.inputText
            }
            let old = this.$gb.userFulled || {}
            old.goals = goals
            this.$gb.userFulled = old
            this.$router.push('/create-user-full-exp')
        },
    }
}
</script>